import {Settings} from './types';
import {createEntityReduxFactory} from '@di-nxt/resource-container';
import {registerWithStore} from '../../../../store/registerWithStore';

export const settingsRedux = createEntityReduxFactory<Settings>(
  'settings',
  'userId',
);

registerWithStore(settingsRedux, 'persistent');
